export default __webpack_public_path__ + "static/media/esophagus_plot_female.cf48f991.png";